import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    snCompute: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
  };

export const toolSlice = createSlice({
  name: 'tool',
  initialState,
  reducers: {
    
    doSNCompute: (state) => {
        state.snCompute.requesting = true;
        state.snCompute.error = null;
        state.snCompute.data = null;
        state.snCompute.success = false; 
    },
    doSNComputeSuccess: (state, action) => {
        state.snCompute.requesting = false;
        state.snCompute.data = action.payload;
        state.snCompute.success = true; 
    },
    doSNComputeFail: (state, action) => {        
        state.snCompute.requesting = false;
        state.snCompute.error = action.payload;
    },
  },
})

export const { 
    doSNCompute, doSNComputeSuccess, doSNComputeFail,
} = toolSlice.actions

export default toolSlice.reducer